import { render, staticRenderFns } from "./address-form.vue?vue&type=template&id=74bb4684&scoped=true&"
import script from "./address-form.vue?vue&type=script&lang=js&"
export * from "./address-form.vue?vue&type=script&lang=js&"
import style0 from "./address-form.vue?vue&type=style&index=0&id=74bb4684&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bb4684",
  null
  
)

export default component.exports